import React from 'react';
import { ChevronDown } from 'lucide-react';

// 国家代码到中文名称的映射
const countryMapping = {
  'CHIN': '中国大陆',
  'TWAN': '中国台湾',
  'HNK': '中国香港特别行政区',
  'MAC': '中国澳门特别行政区',
  'AFGH': '阿富汗', 'ALB': '阿尔巴尼亚', 'ALGR': '阿尔及利亚', 'ASMO': '美属萨摩亚',
  'ANDO': '安道尔', 'ANGL': '安哥拉', 'ANGU': '安圭拉', 'ANTI': '安提瓜和巴布达',
  'ARG': '阿根廷', 'ARM': '亚美尼亚', 'ARB': '阿鲁巴', 'XAS': '海上',
  'ASTL': '澳大利亚', 'AUST': '奥地利', 'AZR': '阿塞拜疆', 'BAMA': '巴哈马',
  'BAHR': '巴林', 'BANG': '孟加拉国', 'BRDO': '巴巴多斯', 'BYS': '白俄罗斯',
  'BELG': '比利时', 'BLZ': '伯利兹', 'BENN': '贝宁', 'BERM': '百慕大',
  'BHU': '不丹', 'BOL': '玻利维亚', 'BIH': '波黑', 'BOT': '博茨瓦纳',
  'BRZL': '巴西', 'IOT': '英属印度洋领土', 'BRNI': '文莱', 'BULG': '保加利亚',
  'BURK': '布基纳法索', 'BURM': '缅甸', 'BRND': '布隆迪', 'CBDA': '柬埔寨',
  'CMRN': '喀麦隆', 'CAN': '加拿大', 'CAVI': '佛得角', 'CAYI': '开曼群岛',
  'CAFR': '中非共和国', 'CHAD': '乍得', 'CHIL': '智利', 
  'CHRI': '圣诞岛', 'COCI': '科科斯群岛', 'COL': '哥伦比亚', 'COMO': '科摩罗',
  'COD': '刚果民主共和国', 'CONB': '刚果共和国', 'CKIS': '库克群岛', 'CSTR': '哥斯达黎加',
  'IVCO': '科特迪瓦', 'HRV': '克罗地亚', 'CUBA': '古巴', 'CUR': '库拉索',
  'CYPR': '塞浦路斯', 'CZEC': '捷克', 'DEN': '丹麦', 'DJI': '吉布提',
  'DOMN': '多米尼克', 'DOMR': '多米尼加', 'ECUA': '厄瓜多尔', 'EGYP': '埃及',
  'ELSL': '萨尔瓦多', 'EGN': '赤道几内亚', 'ERI': '厄立特里亚', 'EST': '爱沙尼亚',
  'SZLD': '斯威士兰', 'ETH': '埃塞俄比亚', 'FKLI': '福克兰群岛', 'FRO': '法罗群岛',
  'FIJI': '斐济', 'FIN': '芬兰', 'FRAN': '法国', 'FPOL': '法属波利尼西亚',
  'FSAT': '法属南部和南极领土', 'GABN': '加蓬', 'GAM': '冈比亚', 'XGZ': '加沙地带',
  'GEO': '格鲁吉亚', 'GER': '德国', 'GHAN': '加纳', 'GIB': '直布罗陀',
  'GRC': '希腊', 'GRLD': '格陵兰', 'GREN': '格林纳达', 'GUAM': '关岛',
  'GUAT': '危地马拉', 'GNEA': '几内亚', 'GUIB': '几内亚比绍', 'GUY': '圭亚那',
  'HAT': '海地', 'HMD': '赫德岛和麦克唐纳群岛', 'VAT': '梵蒂冈', 'HOND': '洪都拉斯',
  'HOKO': '香港英国国民',  'XHI': '豪兰岛', 'HUNG': '匈牙利',
  'ICLD': '冰岛', 'XIR': '空中', 'IND': '印度', 'IDSA': '印度尼西亚',
  'IRAN': '伊朗', 'IRAQ': '伊拉克', 'IRE': '爱尔兰', 'ISRL': '以色列',
  'ITLY': '意大利', 'JAM': '牙买加', 'JPN': '日本', 'JRSM': '耶路撒冷',
  'JORD': '约旦', 'KAZ': '哈萨克斯坦', 'KENY': '肯尼亚', 'KIRI': '基里巴斯',
  'PRK': '朝鲜', 'KOR': '韩国', 'KSV': '科索沃', 'KUWT': '科威特',
  'KGZ': '吉尔吉斯斯坦', 'LAOS': '老挝', 'LATV': '拉脱维亚', 'LEBN': '黎巴嫩',
  'LES': '莱索托', 'LIBR': '利比里亚', 'LBYA': '利比亚', 'LCHT': '列支敦士登',
  'LITH': '立陶宛', 'LXM': '卢森堡',  'MKD': '北马其顿',
  'MADG': '马达加斯加', 'MALW': '马拉维', 'MLAS': '马来西亚', 'MLDI': '马尔登岛',
  'MLDV': '马尔代夫', 'MALI': '马里', 'MLTA': '马耳他', 'RMI': '马绍尔群岛',
  'MAUR': '毛里塔尼亚', 'MRTS': '毛里求斯', 'MYT': '马约特', 'FSM': '密克罗尼西亚',
  'MDWI': '中途岛', 'MLD': '摩尔多瓦', 'MON': '摩纳哥', 'MONG': '蒙古',
  'MTG': '黑山', 'MONT': '蒙特塞拉特', 'MORO': '摩洛哥', 'MOZ': '莫桑比克',
  'NAMB': '纳米比亚', 'NAU': '瑙鲁', 'NEP': '尼泊尔', 'NETH': '荷兰',
  'NCAL': '新喀里多尼亚', 'NZLD': '新西兰', 'NIC': '尼加拉瓜', 'NIR': '尼日尔',
  'NRA': '尼日利亚', 'NIUE': '纽埃', 'NFK': '诺福克岛', 'MNP': '北马里亚纳群岛',
  'NIRE': '北爱尔兰', 'NORW': '挪威', 'OMAN': '阿曼', 'PKST': '巴基斯坦',
  'PALA': '帕劳', 'PLMR': '巴尔米拉环礁', 'PAN': '巴拿马', 'PNG': '巴布亚新几内亚',
  'PARA': '巴拉圭', 'PERU': '秘鲁', 'PHIL': '菲律宾', 'PITC': '皮特凯恩群岛',
  'POL': '波兰', 'PORT': '葡萄牙', 'PR': '波多黎各', 'QTAR': '卡塔尔',
  'ROM': '罗马尼亚', 'RUS': '俄罗斯', 'RWND': '卢旺达', 'MAF': '圣马丁',
  'WSAM': '萨摩亚', 'SMAR': '圣马力诺', 'STPR': '圣多美和普林西比', 'SARB': '沙特阿拉伯',
  'SENG': '塞内加尔', 'SBA': '塞尔维亚', 'SEYC': '塞舌尔', 'SLEO': '塞拉利昂',
  'SING': '新加坡', 'STM': '荷属圣马丁', 'SVK': '斯洛伐克', 'SVN': '斯洛文尼亚',
  'SLMN': '所罗门群岛', 'SOMA': '索马里', 'SAFR': '南非', 'SGS': '南乔治亚和南桑威奇群岛',
  'SSDN': '南苏丹', 'SPN': '西班牙', 'SRL': '斯里兰卡', 'STBR': '圣巴泰勒米',
  'SHEL': '圣赫勒拿', 'STCN': '圣基茨和尼维斯', 'SLCA': '圣卢西亚', 'SPMI': '圣皮埃尔和密克隆',
  'STVN': '圣文森特和格林纳丁斯', 'SUDA': '苏丹', 'SURM': '苏里南', 'SJM': '斯瓦尔巴群岛',
  'SWDN': '瑞典', 'SWTZ': '瑞士', 'SYR': '叙利亚', 
  'TJK': '塔吉克斯坦', 'TAZN': '坦桑尼亚', 'THAI': '泰国', 'TMOR': '东帝汶',
  'TOGO': '多哥', 'TKL': '托克劳', 'TONG': '汤加', 'TRIN': '特立尼达和多巴哥',
  'TNSA': '突尼斯', 'TRKY': '土耳其', 'TKM': '土库曼斯坦', 'TCIS': '特克斯和凯科斯群岛',
  'TUV': '图瓦卢', 'UGAN': '乌干达', 'UKR': '乌克兰', 'UAE': '阿联酋',
  'GRBR': '英国', 'USA': '美国', 'URU': '乌拉圭', 'UZB': '乌兹别克斯坦',
  'VANU': '瓦努阿图', 'VENZ': '委内瑞拉', 'VTNM': '越南', 'VI': '美属维尔京群岛',
  'BRVI': '英属维尔京群岛', 'WKI': '威克岛', 'WAFT': '瓦利斯和富图纳群岛', 'XWB': '西岸',
  'SSAH': '西撒哈拉', 'YEM': '也门', 'ZAMB': '赞比亚', 'ZIMB': '津巴布韦'
};

// 获取国家中文名称的工具函数
export const getCountryName = (code) => {
  return countryMapping[code] || code;
};

// 国家列表 - 按要求排序：中国地区 → 美国 → 其余国家按汉语拼音排序
const countryList = [
  // 优先显示的中国地区
  { code: 'CHIN', name: '中国大陆' },
  { code: 'HNK', name: '中国香港特别行政区' },
  { code: 'TWAN', name: '中国台湾' },
  { code: 'MAC', name: '中国澳门特别行政区' },

  // 美国优先显示
  { code: 'USA', name: '美国' },

  // 其余国家按汉语拼音排序
  { code: 'AFGH', name: '阿富汗' },
  { code: 'ALB', name: '阿尔巴尼亚' },
  { code: 'ALGR', name: '阿尔及利亚' },
  { code: 'ARG', name: '阿根廷' },
  { code: 'ARM', name: '亚美尼亚' },
  { code: 'ARB', name: '阿鲁巴' },
  { code: 'ASTL', name: '澳大利亚' },
  { code: 'AUST', name: '奥地利' },
  { code: 'AZR', name: '阿塞拜疆' },
  { code: 'ANDO', name: '安道尔' },
  { code: 'ANGL', name: '安哥拉' },
  { code: 'ANGU', name: '安圭拉' },
  { code: 'ANTI', name: '安提瓜和巴布达' },
  { code: 'UAE', name: '阿联酋' },
  { code: 'OMAN', name: '阿曼' },
  { code: 'EST', name: '爱沙尼亚' },
  { code: 'IRE', name: '爱尔兰' },
  { code: 'ETH', name: '埃塞俄比亚' },
  { code: 'EGYP', name: '埃及' },

  { code: 'BAHR', name: '巴林' },
  { code: 'BAMA', name: '巴哈马' },
  { code: 'PKST', name: '巴基斯坦' },
  { code: 'PARA', name: '巴拉圭' },
  { code: 'PAN', name: '巴拿马' },
  { code: 'BRZL', name: '巴西' },
  { code: 'BRDO', name: '巴巴多斯' },
  { code: 'PNG', name: '巴布亚新几内亚' },
  { code: 'BYS', name: '白俄罗斯' },
  { code: 'BERM', name: '百慕大' },
  { code: 'BULG', name: '保加利亚' },
  { code: 'BELG', name: '比利时' },
  { code: 'ICLD', name: '冰岛' },
  { code: 'BENN', name: '贝宁' },
  { code: 'BLZ', name: '伯利兹' },
  { code: 'BOT', name: '博茨瓦纳' },
  { code: 'BOL', name: '玻利维亚' },
  { code: 'BIH', name: '波黑' },
  { code: 'POL', name: '波兰' },
  { code: 'PR', name: '波多黎各' },
  { code: 'BHU', name: '不丹' },
  { code: 'BURK', name: '布基纳法索' },
  { code: 'BRND', name: '布隆迪' },
  { code: 'MKD', name: '北马其顿' },
  { code: 'MNP', name: '北马里亚纳群岛' },
  { code: 'NIRE', name: '北爱尔兰' },

  { code: 'PRK', name: '朝鲜' },
  { code: 'CBDA', name: '柬埔寨' },
  { code: 'CHAD', name: '乍得' },
  { code: 'EGN', name: '赤道几内亚' },

  { code: 'DEN', name: '丹麦' },
  { code: 'GER', name: '德国' },
  { code: 'TMOR', name: '东帝汶' },
  { code: 'TOGO', name: '多哥' },
  { code: 'DOMN', name: '多米尼克' },
  { code: 'DOMR', name: '多米尼加' },

  { code: 'RUS', name: '俄罗斯' },
  { code: 'ECUA', name: '厄瓜多尔' },
  { code: 'ERI', name: '厄立特里亚' },

  { code: 'FRAN', name: '法国' },
  { code: 'FKLI', name: '福克兰群岛' },
  { code: 'FRO', name: '法罗群岛' },
  { code: 'FPOL', name: '法属波利尼西亚' },
  { code: 'FSAT', name: '法属南部和南极领土' },
  { code: 'CAVI', name: '佛得角' },
  { code: 'FIJI', name: '斐济' },
  { code: 'FIN', name: '芬兰' },
  { code: 'PHIL', name: '菲律宾' },
  { code: 'VAT', name: '梵蒂冈' },

  { code: 'CONB', name: '刚果共和国' },
  { code: 'COD', name: '刚果民主共和国' },
  { code: 'COL', name: '哥伦比亚' },
  { code: 'CSTR', name: '哥斯达黎加' },
  { code: 'GREN', name: '格林纳达' },
  { code: 'GEO', name: '格鲁吉亚' },
  { code: 'GRLD', name: '格陵兰' },
  { code: 'CUBA', name: '古巴' },
  { code: 'GUAM', name: '关岛' },
  { code: 'GUY', name: '圭亚那' },

  { code: 'KAZ', name: '哈萨克斯坦' },
  { code: 'HAT', name: '海地' },
  { code: 'KOR', name: '韩国' },
  { code: 'HOND', name: '洪都拉斯' },
  { code: 'NETH', name: '荷兰' },
  { code: 'STM', name: '荷属圣马丁' },
  { code: 'MTG', name: '黑山' },
  { code: 'HRV', name: '克罗地亚' },
  { code: 'HMD', name: '赫德岛和麦克唐纳群岛' },
  { code: 'XHI', name: '豪兰岛' },
  { code: 'XAS', name: '海上' },
  { code: 'HOKO', name: '香港英国国民' },

  { code: 'JPN', name: '日本' },
  { code: 'SWTZ', name: '瑞士' },
  { code: 'SWDN', name: '瑞典' },

  { code: 'GHAN', name: '加纳' },
  { code: 'GABN', name: '加蓬' },
  { code: 'CAN', name: '加拿大' },
  { code: 'GNEA', name: '几内亚' },
  { code: 'GUIB', name: '几内亚比绍' },
  { code: 'KIRI', name: '基里巴斯' },
  { code: 'DJI', name: '吉布提' },
  { code: 'KGZ', name: '吉尔吉斯斯坦' },
  { code: 'CZEC', name: '捷克' },
  { code: 'ZIMB', name: '津巴布韦' },
  { code: 'XGZ', name: '加沙地带' },

  { code: 'CMRN', name: '喀麦隆' },
  { code: 'QTAR', name: '卡塔尔' },
  { code: 'CAYI', name: '开曼群岛' },
  { code: 'COMO', name: '科摩罗' },
  { code: 'IVCO', name: '科特迪瓦' },
  { code: 'COCI', name: '科科斯群岛' },
  { code: 'KUWT', name: '科威特' },
  { code: 'KENY', name: '肯尼亚' },
  { code: 'CKIS', name: '库克群岛' },
  { code: 'CUR', name: '库拉索' },
  { code: 'XIR', name: '空中' },

  { code: 'LAOS', name: '老挝' },
  { code: 'LATV', name: '拉脱维亚' },
  { code: 'LES', name: '莱索托' },
  { code: 'LCHT', name: '列支敦士登' },
  { code: 'LITH', name: '立陶宛' },
  { code: 'LIBR', name: '利比里亚' },
  { code: 'LBYA', name: '利比亚' },
  { code: 'LEBN', name: '黎巴嫩' },
  { code: 'LXM', name: '卢森堡' },
  { code: 'RWND', name: '卢旺达' },

  { code: 'MLDV', name: '马尔代夫' },
  { code: 'MLTA', name: '马耳他' },
  { code: 'MALW', name: '马拉维' },
  { code: 'MALI', name: '马里' },
  { code: 'RMI', name: '马绍尔群岛' },
  { code: 'MADG', name: '马达加斯加' },
  { code: 'MYT', name: '马约特' },
  { code: 'MLAS', name: '马来西亚' },
  { code: 'MON', name: '摩纳哥' },
  { code: 'MORO', name: '摩洛哥' },
  { code: 'MLD', name: '摩尔多瓦' },
  { code: 'MAUR', name: '毛里塔尼亚' },
  { code: 'MRTS', name: '毛里求斯' },
  { code: 'BURM', name: '缅甸' },
  { code: 'FSM', name: '密克罗尼西亚' },
  { code: 'PERU', name: '秘鲁' },
  { code: 'MONG', name: '蒙古' },
  { code: 'BANG', name: '孟加拉国' },
  { code: 'MONT', name: '蒙特塞拉特' },
  { code: 'ASMO', name: '美属萨摩亚' },
  { code: 'VI', name: '美属维尔京群岛' },

  { code: 'NAMB', name: '纳米比亚' },
  { code: 'SAFR', name: '南非' },
  { code: 'SGS', name: '南乔治亚和南桑威奇群岛' },
  { code: 'SSDN', name: '南苏丹' },
  { code: 'NAU', name: '瑙鲁' },
  { code: 'NEP', name: '尼泊尔' },
  { code: 'NIC', name: '尼加拉瓜' },
  { code: 'NIR', name: '尼日尔' },
  { code: 'NRA', name: '尼日利亚' },
  { code: 'NIUE', name: '纽埃' },
  { code: 'NORW', name: '挪威' },
  { code: 'NFK', name: '诺福克岛' },

  { code: 'PALA', name: '帕劳' },
  { code: 'PITC', name: '皮特凯恩群岛' },
  { code: 'PORT', name: '葡萄牙' },

  { code: 'JRSM', name: '耶路撒冷' },
  { code: 'JORD', name: '约旦' },
  { code: 'VTNM', name: '越南' },

  { code: 'CHIL', name: '智利' },
  { code: 'CAFR', name: '中非共和国' },
  { code: 'MDWI', name: '中途岛' },
  { code: 'GIB', name: '直布罗陀' },

  { code: 'SLEO', name: '塞拉利昂' },
  { code: 'CYPR', name: '塞浦路斯' },
  { code: 'SEYC', name: '塞舌尔' },
  { code: 'SENG', name: '塞内加尔' },
  { code: 'SBA', name: '塞尔维亚' },
  { code: 'SLMN', name: '所罗门群岛' },
  { code: 'SOMA', name: '索马里' },
  { code: 'SRL', name: '斯里兰卡' },
  { code: 'SVK', name: '斯洛伐克' },
  { code: 'SVN', name: '斯洛文尼亚' },
  { code: 'SZLD', name: '斯威士兰' },
  { code: 'SJM', name: '斯瓦尔巴群岛' },
  { code: 'SUDA', name: '苏丹' },
  { code: 'SURM', name: '苏里南' },
  { code: 'ELSL', name: '萨尔瓦多' },
  { code: 'WSAM', name: '萨摩亚' },
  { code: 'SMAR', name: '圣马力诺' },
  { code: 'STPR', name: '圣多美和普林西比' },
  { code: 'MAF', name: '圣马丁' },
  { code: 'STBR', name: '圣巴泰勒米' },
  { code: 'SHEL', name: '圣赫勒拿' },
  { code: 'STCN', name: '圣基茨和尼维斯' },
  { code: 'SLCA', name: '圣卢西亚' },
  { code: 'SPMI', name: '圣皮埃尔和密克隆' },
  { code: 'STVN', name: '圣文森特和格林纳丁斯' },
  { code: 'CHRI', name: '圣诞岛' },
  { code: 'SARB', name: '沙特阿拉伯' },

  { code: 'TJK', name: '塔吉克斯坦' },
  { code: 'THAI', name: '泰国' },
  { code: 'TAZN', name: '坦桑尼亚' },
  { code: 'TONG', name: '汤加' },
  { code: 'TKL', name: '托克劳' },
  { code: 'TCIS', name: '特克斯和凯科斯群岛' },
  { code: 'TRIN', name: '特立尼达和多巴哥' },
  { code: 'TNSA', name: '突尼斯' },
  { code: 'TUV', name: '图瓦卢' },
  { code: 'TRKY', name: '土耳其' },
  { code: 'TKM', name: '土库曼斯坦' },

  { code: 'VANU', name: '瓦努阿图' },
  { code: 'WAFT', name: '瓦利斯和富图纳群岛' },
  { code: 'GUAT', name: '危地马拉' },
  { code: 'VENZ', name: '委内瑞拉' },
  { code: 'BRNI', name: '文莱' },
  { code: 'UGAN', name: '乌干达' },
  { code: 'UKR', name: '乌克兰' },
  { code: 'URU', name: '乌拉圭' },
  { code: 'UZB', name: '乌兹别克斯坦' },
  { code: 'WKI', name: '威克岛' },

  { code: 'SPN', name: '西班牙' },
  { code: 'GRC', name: '希腊' },
  { code: 'SING', name: '新加坡' },
  { code: 'NZLD', name: '新西兰' },
  { code: 'NCAL', name: '新喀里多尼亚' },
  { code: 'HUNG', name: '匈牙利' },
  { code: 'SYR', name: '叙利亚' },
  { code: 'XWB', name: '西岸' },
  { code: 'SSAH', name: '西撒哈拉' },

  { code: 'JAM', name: '牙买加' },
  { code: 'YEM', name: '也门' },
  { code: 'IRAQ', name: '伊拉克' },
  { code: 'IRAN', name: '伊朗' },
  { code: 'ISRL', name: '以色列' },
  { code: 'ITLY', name: '意大利' },
  { code: 'IND', name: '印度' },
  { code: 'IDSA', name: '印度尼西亚' },
  { code: 'GRBR', name: '英国' },
  { code: 'IOT', name: '英属印度洋领土' },
  { code: 'BRVI', name: '英属维尔京群岛' },

  { code: 'ZAMB', name: '赞比亚' },

  // 墨西哥各州（保持原有顺序）
  { code: 'AGS', name: '墨西哥-阿瓜斯卡连特斯' },
  { code: 'BC', name: '墨西哥-下加利福尼亚' },
  { code: 'BCSR', name: '墨西哥-南下加利福尼亚' },
  { code: 'CAMP', name: '墨西哥-坎佩切' },
  { code: 'CHIS', name: '墨西哥-恰帕斯' },
  { code: 'CHIH', name: '墨西哥-奇瓦瓦' },
  { code: 'COAH', name: '墨西哥-科阿韦拉' },
  { code: 'COLI', name: '墨西哥-科利马' },
  { code: 'DF', name: '墨西哥-联邦区' },
  { code: 'DGO', name: '墨西哥-杜兰戈' },
  { code: 'GTO', name: '墨西哥-瓜纳华托' },
  { code: 'GRO', name: '墨西哥-格雷罗' },
  { code: 'HGO', name: '墨西哥-伊达尔戈' },
  { code: 'JAL', name: '墨西哥-哈利斯科' },
  { code: 'MCH', name: '墨西哥-米却肯' },
  { code: 'MOR', name: '墨西哥-莫雷洛斯' },
  { code: 'NAY', name: '墨西哥-纳亚里特' },
  { code: 'NL', name: '墨西哥-新莱昂' },
  { code: 'OAX', name: '墨西哥-瓦哈卡' },
  { code: 'PUE', name: '墨西哥-普埃布拉' },
  { code: 'QRO', name: '墨西哥-克雷塔罗' },
  { code: 'QROO', name: '墨西哥-金塔纳罗奥' },
  { code: 'SLP', name: '墨西哥-圣路易斯波托西' },
  { code: 'SIN', name: '墨西哥-锡那罗亚' },
  { code: 'SON', name: '墨西哥-索诺拉' },
  { code: 'MXCO', name: '墨西哥-墨西哥州' },
  { code: 'TAB', name: '墨西哥-塔巴斯科' },
  { code: 'TAMP', name: '墨西哥-塔毛利帕斯' },
  { code: 'TLAX', name: '墨西哥-特拉斯卡拉' },
  { code: 'VER', name: '墨西哥-韦拉克鲁斯' },
  { code: 'YUC', name: '墨西哥-尤卡坦' },
  { code: 'ZAC', name: '墨西哥-萨卡特卡斯' },

  // 特殊地区
  { code: 'GAM', name: '冈比亚' },
  { code: 'KSV', name: '科索沃' },
  { code: 'ROM', name: '罗马尼亚' },
  { code: 'PLMR', name: '巴尔米拉环礁' },
  { code: 'MLDI', name: '马尔登岛' }
];

// 国家选择组件
const CountrySelect = ({ label = "出生国家", value, onChange, required = false, excludeCountries = [] }) => {
  // 过滤排除的国家
  const filteredCountries = countryList.filter(country => !excludeCountries.includes(country.code));
  
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full h-12 px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gradient-to-r from-white to-gray-50 shadow-sm hover:shadow-md transition-all duration-200 appearance-none cursor-pointer font-medium"
        >
          <option value="" className="text-gray-500">请选择...</option>
          {filteredCountries.map(country => (
            <option key={country.code} value={country.code} className="text-gray-800 py-2">{country.name}</option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <ChevronDown className="h-5 w-5 text-gray-400" />
        </div>
      </div>
    </div>
  );
};

export default CountrySelect;